import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';

import { map } from 'rxjs';

import { ChurnReason } from '@core/churn-flow-types';

import { ChurnFlowDataBaseService } from './churn-flow-data-base.service';

export const ChurnReasonsGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(ChurnFlowDataBaseService).lockedChurnReason.pipe(
    map((reason: ChurnReason) => {
      // If there is no reason selected, allow access to the route
      // Otherwise, redirect to the specific reason page
      if (!reason) return true;
      return new RedirectCommand(
        router.createUrlTree([{ outlets: { dialog: ['churn', reason] } }], {
          queryParams: { 'display-reason-infobox': true },
        }),
      );
    }),
  );
};
